import React from 'react';

import ExternalLink from 'src/components/common/external-link';
import Video from 'src/components/common/video';
import CompanyContacts from '../company-contacts';

import { CEMETERY_URL, PromoVideo } from 'src/constants';

import './info.scss';

const Info = () => {
  return (
    <div className="info">
      <section className="info__section">
        <div className="info__company-card">
          <h2 className="info__company">עתיד מוניציפלי בע&quot;מ, ח.פ. 516481736</h2>
          <CompanyContacts
            address="יוסף ספיר 6, נתניה"
            email="info@bezikaron.co.il"
            phone="0547310054"
            website={CEMETERY_URL}
          />
          <div className="info__text">
            כל השאלות הנוספות, הצאות ודרישות שלחו למייל <br />
            <ExternalLink className="info__link" href="mailto:support@bezikaron.co.il">
              support@bezikaron.co.il
            </ExternalLink>
          </div>
        </div>
        {PromoVideo.URL && <Video className="info__video" src={PromoVideo.URL} />}
      </section>
    </div>
  );
};

export default Info;
